//services
import API from 'services/api.services';
//constants
import {
	API_DO_CONVERT,
	API_GET_CONVERSION_RATE,
	API_GET_CONVERT_BY_ID,
	API_GET_CONVERT_DATES,
} from 'constants/db.constants';
import { Convert, ConvertData, convertSteps } from 'constants/convert.constants';
import { intialMessage, userMesaageType } from 'constants/ui.constants';

//reducers
import {
	setActiveStep,
	setConversionData,
	setCurrentConversionResponse,
	setCutOffTime,
	setExpired,
	setLoading,
	setMessage,
	setOptionalDates,
	upsertConvert,
} from 'state/reducers/convert.reducers';
import _ from 'lodash';
import { getBalancesByCompanyId } from './balance.services';
import Event from '@mui/icons-material/Event';
import { setErrorMessage } from 'utils';
import { getActivitiesAsync } from './activity.services';
import { subDays } from 'date-fns';
import { store } from 'state/store';

export function getQuote(convert: Convert, currencies, currency?: any) {
	//TODO: change name validateStep1 to more clear
	return async (dispatch: any, getState: any) => {
		// where do i get the companyId
		// do we have the currency ids?
		const buyCurrency = _.find(currencies, { code: convert.buy_currency });
		const sellCurrency = _.find(currencies, { code: convert.sell_currency });
		const { translation } = getState();
		dispatch(setLoading(true));
		dispatch(setMessage(intialMessage));
		try {
			let res = await API.getInstance().post(API_GET_CONVERSION_RATE, {
				buyCurrency: convert.buy_currency,
				sellCurrency: convert.sell_currency,
				amount: convert.amount,
				action: convert.type,
				companyId: convert.companyId,
				buyCurrencyId: buyCurrency.id,
				sellCurrencyId: sellCurrency.id,
				dueDate: convert.conversion_date,
			});
			dispatch(setLoading(false));
			dispatch(
				setConversionData({
					...res.data,
					conversion_date: convert.conversion_date,
				})
			);
			dispatch(setExpired(false));
			try {
				if (currency && res.data.altshulerSellAmount > currency.amount) {
					const translate = translation.translations[translation.language] || {};
					let subtext = _.replace(
						'Conversion of ${currency} equivalent ${amount} exceeds your limit of ${limit_amount}',
						'${currency}',
						currency.code
					);
					subtext = _.replace(
						subtext,
						'${amount}',
						currency.symbol + '' + Math.round(res.data.altshulerSellAmount)
					);
					subtext = _.replace(subtext, '${limit_amount}', currency.symbol + currency.amount);
					/** translation dont support replace values.
					 * use for now with constant text */
					dispatch(
						setMessage({
							exist: true,
							type: userMesaageType.ERROR,
							text: 'page.convert.popup.exceeds_limit.text',
							//subText: subtext,
						})
					);
				} else {
					dispatch(setActiveStep(convertSteps.REVIEW));
				}
			} catch (e) {
				console.log(e);
				dispatch(setActiveStep(convertSteps.REVIEW));
			}
		} catch (e: any) {
			dispatch(setLoading(false));
			//console.log(e)
			//if (_.get(e, 'statusCode') === 500) {
			setErrorMessage(setMessage, e);
			//}
		}
	};
}

export function getConvertDates(buyCurrencyCode: string, sellCurrencyCode: string) {
	//TODO: change name validateStep1 to more clear
	return async (dispatch: any) => {
		dispatch(upsertConvert({ conversion_date: undefined }));
		dispatch(setLoading(true));
		dispatch(setMessage(intialMessage));
		try {
			let res = await API.getInstance().post(API_GET_CONVERT_DATES, {
				buyCurrencyCode: buyCurrencyCode,
				sellCurrencyCode: sellCurrencyCode,
			});
			dispatch(setLoading(false));
			dispatch(setOptionalDates(res.data.conversionDates));
			dispatch(setCutOffTime(res.data.cutOffTime));
			if (res?.data.length === 0) {
				dispatch(
					setMessage({
						exist: true,
						type: userMesaageType.WARNING,
						text: 'There is no trade, you can make a conversion on the next business date',
						icon: Event,
					})
				);
			}
		} catch (e: any) {
			dispatch(setLoading(false));
			dispatch(setOptionalDates([]));
			dispatch(setCutOffTime(null));
			//if (_.includes([404, 500], _.get(e, 'statusCode'))) {
			setErrorMessage(setMessage, e);
			//}
		}
	};
}

export function validateStep3(convertData: ConvertData) {
	//TODO: change name validateStep1 to more clear
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setMessage(intialMessage));
		try {
			let res = await API.getInstance().post(API_DO_CONVERT, {
				companyId: convertData.company_id,
				pendingQuoteId: convertData.pendingQuoteId,
				termAgreement: convertData.termAgreement ?? false,
			});
			dispatch(setLoading(false));
			dispatch(setCurrentConversionResponse(res.data));
			dispatch(setActiveStep(convertSteps.COMPLETE));
			dispatch(getBalancesByCompanyId());
			dispatch(
				getActivitiesAsync(store.getState().user?.details?.companyId, subDays(new Date(), 10), new Date())
			);
		} catch (e: any) {
			dispatch(setLoading(false));
			//if (_.includes([400, 403, 404, 500], _.get(e, 'statusCode'))) {
			setErrorMessage(setMessage, e);
			//}
		}
	};
}

export function getConvertById(id: string) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setMessage(intialMessage));
		try {
			let res = await API.getInstance().post(API_GET_CONVERT_BY_ID, { conversionId: id });
			dispatch(setLoading(false));
			return res?.data?.conversion;
		} catch (e: any) {
			dispatch(setLoading(false));
			setErrorMessage(setMessage, e);
		}
	};
}
